import React from "react";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
export default function WorkdocRolesSection({ section = {} }) {
  return (
    <div className="workdoc-role-section mb-3">
      {section.statelabel && (
        <span className="small text-muted  mr-1">
          <EssenceStateLabel
            stateCode={section.statecode}
            stateLabel={section.statelabel}
          />

          <i className="fa fa-arrow-right text-dark-25 mx-1"></i>
        </span>
      )}
      <span className="small text-dark mr-2">{section.activityname}</span>
    </div>
  );
}
